import { z } from 'zod';

const reportIdSchema = z.string().uuid();

/**
 * Returns whether a route param is a valid report UUID.
 * @param value - Raw `:reportId` route segment.
 * @returns True when the value is a UUID v4-style string.
 */
export const isReportUuid = (value: string | undefined): boolean => {
  if (!value) {
    return false;
  }
  return reportIdSchema.safeParse(value).success;
};
